import { render, staticRenderFns } from "./profileSkeleton.vue?vue&type=template&id=34258d10&scoped=true"
import script from "./profileSkeleton.vue?vue&type=script&lang=js"
export * from "./profileSkeleton.vue?vue&type=script&lang=js"
import style0 from "./profileSkeleton.vue?vue&type=style&index=0&id=34258d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34258d10",
  null
  
)

export default component.exports